var isNil = function isNil(value) {
  return value === undefined || value === null;
};
var notNil = function notNil(value) {
  return !isNil(value);
};
var whenNil = function whenNil(value, defaultValue) {
  return isNil(value) ? defaultValue : value;
};
var whenNotNil = function whenNotNil(value, defaultValue) {
  return notNil(value) ? value : defaultValue;
};

export { isNil, notNil, whenNil, whenNotNil };
